import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetUserRes, UpdateUserReq, UpdateUserRes } from '../models';

export interface UserApi {
  getUser(): Observable<GetUserRes>;
  updateUser(params: UpdateUserReq): Observable<UpdateUserRes>;
}

export const USER_API = new InjectionToken<UserApi>('USER_API');
